module.exports = __webpack_public_path__ + "static/media/Assets-05-MNM-03.4da54c6f.png";